import React, {useEffect, useState} from 'react';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {Row} from '../../../../../components/layout';

interface FilledRadioButtonProps {
  globalStyles: any;
  width?: any;
  height?: any;
}

function FilledRadioButton({
  globalStyles,
  width,
  height,
}: FilledRadioButtonProps) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  function getWindowWidth() {
    const {innerWidth: width, innerHeight: height} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <title>865A5405-3BC3-47D3-A994-35ABFE98EF82@1,5x</title>
      <g
        id="08---Consultas-Online"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="MY-M-08-01-09-Pagamento-cartao-de-credito"
          transform="translate(-44.000000, -792.000000)">
          <g id="Checkbox" transform="translate(44.000000, 792.000000)">
            <circle
              id="Oval"
              stroke={globalStyles.primaryColor}
              strokeWidth="2"
              fill="#FFFFFF"
              cx="12"
              cy="12"
              r="11"></circle>
            <path
              d="M12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 Z"
              id="Selected"
              fill={globalStyles.primaryColor}
              fillRule="nonzero"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(FilledRadioButton));
